<template>
  <div class="wallet">
    <div class="page-header">
      <i class="back-icon" @click="$router.go(-1)"></i>
      <span>My Wallet</span>
    </div>
    <div class="account">
      <span>My Balance</span>
      <span class="money">{{ userInfo.coin }}</span>
    </div>
    <div class="record">
      <InfiniteScroll :load="loadMore" :loading="loading">
        <div class="item" v-for="item in recordList" :key="item.id">
          <div class="info">
            <p class="title">{{ item.remark }}</p>
            <p class="date">{{ item.created_at }}</p>
          </div>
          <div :class="['count', {'minus': item.action === 2}]">{{ item.action === 1 ? '+' : '-'}}{{ item.amount }}</div>
        </div>
      </InfiniteScroll>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import { getBalanceRecord } from '@/api';
import InfiniteScroll from '@/components/InfiniteScroll';

export default {
  components: {
    InfiniteScroll,
  },
  created() {
    this.getRecords();
  },
  computed: {
    ...mapState(['userInfo']),
  },
  data() {
    return {
      page: 1,
      limit: 10,
      recordList: [],
      num: 60,
      loading: false,
      hasMore: true,
    };
  },
  methods: {
    ...mapActions(['setUserInfo']),
    async getRecords(type = '') {
      await this.setUserInfo();
      const { page = 1, limit: per_page = 20 } = this;
      const res = await getBalanceRecord({ page, per_page });
      if (res.code !== 0) return;
      const { list = [], has_next = false, current_page = 1 } = res?.data || {};
      type === 'more' ? this.recordList.push(...list) : this.recordList = list;
      this.hasMore = has_next;
      this.page = current_page + 1;
    },
    loadMore() {
      if (!this.hasMore) {
        this.$toast.error('no more records...');
      } else {
        this.getRecords('more');
      }
    },
  },
};
</script>
<style lang="less" scoped>
.wallet {
  .page-header {
    display: flex;
    align-items: center;
    color: @black;
    font-size: @fontLarge;
    font-weight: 700;
    height: 44px;
    padding: 0 16px;
    .back-icon {
      margin-right: 10px;
      .iconMixin({
        background-image: url('~@/assets/images/icon/back.png');
      });
    }
  }
  .account, .record {
    margin: 16px;
    font-size: @fontMedium;
    font-weight: 700;
  }
  .account {
    padding-bottom: 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    .money {
      display: flex;
      align-items: center;
      &::before {
        content: '';
        width: 32px;
        height: 32px;
        background: url(@/assets/images/icon/diamond.png) no-repeat center;
        background-size: 100%;
        margin-right: 8px;
      }
    }
  }
  .item {
    display: flex;
    align-items: center;
    padding: 8px 0;
    margin-bottom: 8px;
    &::before {
      content: '';
      width: 32px;
      height: 32px;
      background: url(@/assets/images/icon/diamond.png) no-repeat center;
      background-size: 100%;
      margin-right: 8px;
    }
    .info {
      font-weight: normal;
      .date {
        color: @gray;
      }
    }
    .count {
      margin-left: auto;
      &.minus {
        color: @red;
      }
    }
  }
}
</style>
